/**
 * OPEN-157 B — the office's half of "Take back": the reason floor, the Unassigned choice, and
 * the words for a refusal (api services/job-takeback.ts is the source of truth).
 */

import { ApiError } from '@lodex-pro/web-shared';

/** job_takebacks_reason_check / the route's floor. */
export const TAKE_BACK_REASON_MIN = 10;

/** The Combobox value for "Unassigned" (sent as toDriverId null). */
export const UNASSIGNED = '__unassigned__';

const REFUSAL_COPY: Readonly<Record<string, string>> = {
  job_not_started: 'This job has not started. Move it on the board instead.',
  job_finished: 'This ticket is finished, so it keeps the driver who hauled it.',
  job_terminal_not_assignable: 'This job is closed, so its driver is not changed.',
  same_driver: 'Choose a different driver.',
  no_driver: 'This job has no driver to take it back from.',
  driver_not_found_or_inactive: 'That driver is not active any more. Choose another.',
};

/** The line for a failed take-back. */
export function takeBackErrorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.code === 'PERMISSION_DENIED') return 'Only a dispatch manager can take a job back.';
    // The driver's running clock has no shift on record, so it cannot be stopped (NULL_SHIFT).
    if (err.code === 'JOB_TRANSITION_FORBIDDEN') {
      return "The driver's clock on this job can't be stopped, so it was not taken back. Contact support.";
    }
    const reason = err.fields[0]?.reason;
    if (reason !== undefined && REFUSAL_COPY[reason] !== undefined) return REFUSAL_COPY[reason];
  }
  return 'Could not take the job back. Try again.';
}
